import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import { BlogDetailsSkeleton, Comments, ErrorComponent } from '../../components';
import BlogNav from '../../components/BlogNav'
import { GET_BLOG_DETAILS } from '../../utils/constants/queries'
import { useQuery } from '@apollo/client';
import renderHTML from 'react-render-html';
import { BLOG } from '../../utils/constants/routes';
export default function BlogDetails(props) {
    const { match: { params } } = props;
    const { loading, error, data } = useQuery(GET_BLOG_DETAILS, {
        variables: {
            id: params.id,
        }
    });
    const blogDetails = loading ? <BlogDetailsSkeleton /> : error ? <ErrorComponent message={error.message} /> :
        <>
            <div className="article-image">
                <img src={data.blog_by_pk.image} alt={data.blog_by_pk.title} />
            </div>
            <div className="article-content">
                <div className="entry-meta">
                    <ul>
                        <li>
                            <span>Posted On:</span>
                            <a href="#">September 31, 2020</a>
                        </li>
                        <li>
                            <span>Posted By:</span>
                            <a href="#">Pr Sam Agaba</a>
                        </li>
                    </ul>
                </div>

                {renderHTML(data.blog_by_pk.blog)}
            </div>
        </>
    return (
        <section className="blog-details-area ptb-200">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        <div className="blog-details-desc">

                                {blogDetails}
                            <div className="article-footer">
                                <div className="article-tags">
                                    <span>
                                        <i className="bx bx-bookmark"></i>
                                    </span>
                                    <Link to={BLOG}>Fashion</Link>,
                                    <Link to={BLOG}>Travel</Link>
                                </div>

                                <div className="article-share">
                                    <ul className="social">
                                        <li><span>Share:</span></li>
                                        <li>
                                            <a href="#" target="_blank">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" target="_blank">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="post-navigation">
                                <div className="navigation-links">
                                    <div className="nav-previous">
                                        <Link to={params.id > 1 ? `/blog/posts/${params.id - 1}` : BLOG}>
                                            <i className="flaticon-left"></i>
                                            Prev Post
                                        </Link>
                                    </div>
                                    <div className="nav-next">
                                        <Link to={params.id < 1 ? `/blog/posts/${params.id + 1}` : BLOG}>
                                            Next Post
                                            <i className="flaticon-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                                <Comments post ={params.id}/>
                            </div>
                    </div>
                    <BlogNav />
                </div>
            </div>
        </section>
    )
}

